module.exports = __webpack_public_path__ + "img/naive-inline.png";